import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ErrorMessageDirective } from '../../misc/directives/error-message.directive';
import { MiscModule } from '../../misc/misc.module';
import { LoginCredentialsPageRoutingModule } from './login-credentials-routing.module';
import { LoginCredentialsPageComponent } from './login-credentials.page';

@NgModule({
  declarations: [LoginCredentialsPageComponent],
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    LoginCredentialsPageRoutingModule,
    ReactiveFormsModule,
    MiscModule,
    ErrorMessageDirective
  ]
})
export class LoginCredentialsPageModule {}
